import React, { useState } from 'react'
import Navbar from './Navbar'
import "../Styles/DeviceTable.css"
import "../Styles/UserCard.css"
import { getUserDetails } from "../Utility/AsyncStorageData";
import Header from "./Header";
import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Modal from "./Modal";
import { showToast } from './Toast';
import Select from "react-select";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

function AddProduct() {

    var userDetails = getUserDetails();
    let navigate = useNavigate();

    const [test, setTest] = React.useState(1);
    const [productList, setProductList] = React.useState([])
    const [isAddVisible, setIsAddVisible] = React.useState(false)
    const [isDelete, setIsDelete] = React.useState(false)
    const [categoryList, setCategoryList] = React.useState([])
    // const [reason, setReason] = React.useState({})
    const [product, setProduct] = React.useState({})
    const [selectedCategoryOption, setSelectedCategoryOption] = React.useState(null);
    const [otherCategory, setOtherCategory] = React.useState("");
    const [selectedOperand, setSelectedOperand] = useState(null);

    const operandOptions = [
        { value: "+", label: "Addition (+)" },
        { value: "-", label: "Subtraction (-)" },
        { value: "*", label: "Multiplication (*)" },
        { value: "/", label: "Division (/)" },
    ];

    const navbarRender = (data) => {
        // console.log('Data received from child:', data);
        setTest(!test)
    };



    const handleChange = (fieldName, value) => {
        setProduct((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };

    const editproduct = async (item) => {
        console.log("editproduct", item)
        console.log("edit", selectedCategoryOption)
        setSelectedCategoryOption({ value: item.id, label: item.product_type });
        setIsAddVisible(true)
        setProduct(item)

        if (item?.operand) {
            const matchedOption = operandOptions.find(
                (opt) => opt.value === item.operand
            );

            setSelectedOperand(matchedOption || null);
        }
    }
    const handleproductList = async () => {
        try {

            let url = process.env.REACT_APP_BASE_URL + "/ws/listProductPart";
            let body = {
                comp_num: userDetails.comp_num,
            }
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        console.log("************companyWiseDeviceList************ ", response.data)
                        setProductList(response.data.list)

                    }
                    else if (response.data.statusCode === 1) {
                        showToast(response.data.msg, 3000, "red");
                    }


                    else {

                        showToast(response.data.msg, 3000, "red");
                        console.log(" companyWiseDeviceList error: ", response.data.msg);
                    }

                    // setLoading (false);
                }


                else if (response.status == 403) {
                    navigate("/");
                }

            }).catch(error => {
                console.log("error: ", error);
                showToast("Slow or no internet connected. Please check your internet connection.", 3000, "red");

                // Alert.alert("ERROR")

                return
            })
        } catch (error) {
            console.log("error1 ", error)
            showToast(error, 3000, "red");
            return
        }
    }


    const handleCategory = async () => {
        try {

            let url = process.env.REACT_APP_BASE_URL + "/ws/listOfProductCategory";
            let body = {
                comp_num: userDetails.comp_num,
            }
            // console.log("************companyWiseDeviceList************ ", body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        console.log("************setCategoryList************ ", response.data)
                        // setCategoryList(response.data.list)
                        // const formattedOptions = response.data.list.map((item) => ({
                        //     value: item.id,
                        //     label: item.product_type,
                        // }));
                        const formattedOptions = [...response.data.list.map((item) => ({ value: item.id, label: item.product_type })),
                        { value: "other", label: "Other" }]
                        setCategoryList(formattedOptions);

                    }
                    else if (response.data.statusCode === 1) {
                        showToast(response.data.msg, 3000, "red");
                    }


                    else {

                        showToast(response.data.msg, 3000, "red");
                        console.log(" companyWiseDeviceList error: ", response.data.msg);
                    }

                    // setLoading (false);
                }


                else if (response.status == 403) {
                    navigate("/");
                }

            }).catch(error => {
                console.log("error: ", error);
                showToast("Slow or no internet connected. Please check your internet connection.", 3000, "red");

                // Alert.alert("ERROR")

                return
            })
        } catch (error) {
            console.log("error1 ", error)
            showToast(error, 3000, "red");
            return
        }
    }


    const submitProduct = async () => {
        // console.log("reason", reason)
        try {

            let url = process.env.REACT_APP_BASE_URL + "/ws/productPartCruds";
            let body = {
                part_num: product.id,
                comp_num: userDetails.comp_num,
                part: product.part,
                product_type: selectedCategoryOption.label == "Other" ? otherCategory : selectedCategoryOption.label,
                operand: selectedOperand.value,
                miltiplier: product.miltiplier
            }

            console.log("reasonapi", body)

            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        handleproductList()
                        setIsAddVisible(false)
                        setProduct({})
                        setSelectedOperand(null)
                        setSelectedCategoryOption("")
                        setOtherCategory("")
                        handleCategory()

                        showToast(response.data.msg, 3000, "green");
                    }
                    else if (response.data.statusCode === 1) {
                        console.log(" submitReason error: ", response.data.msg);
                        showToast(response.data.msg, 3000, "red");
                    }


                    else {

                        showToast(response.data.msg, 3000, "red");
                        console.log(" submitReason error: ", response.data.msg);
                    }

                    // setLoading (false);
                }


                else if (response.status == 403) {
                    navigate("/");
                }

                setIsAddVisible(false)
            }).catch(error => {
                console.log("error: ", error);

                showToast(error, 3000, "red");
                return
            })

        } catch (error) {
            showToast(error, 3000, "red");
            return
        }

        setIsAddVisible(false)
        setProduct({})
    }

    const deleteProduct = async () => {
        try {

            let url = process.env.REACT_APP_BASE_URL + "/ws/productPartCruds";
            let body = {
                part_num: product.id,
                comp_num: userDetails.comp_num,
                part: product.part,
                is_active: "N"
            }

            console.log("reasonapi", body)
            await axios.post(url, body, {
                headers: {
                    'authorization': `${userDetails.access_token}`
                },
            }).then(response => {

                if (response.status === 200) {

                    if (response.data.statusCode === 0) {
                        handleproductList()
                        setIsDelete(false)
                        setProduct({})
                        showToast(response.data.msg, 3000, "green");
                    }
                    else if (response.data.statusCode === 1) {
                        console.log(" submitReason error: ", response.data.msg);
                    }


                    else {

                        showToast(response.data.msg, 3000, "red");
                        console.log(" submitReason error: ", response.data.msg);
                    }

                    // setLoading (false);
                }


                else if (response.status == 403) {
                    navigate("/");
                }

                setIsAddVisible(false)
            }).catch(error => {
                console.log("error: ", error);
                showToast(error, 3000, "red");
                return
            })
        } catch (error) {
            console.log("error1 ", error)
            showToast(error, 3000, "red");
            return
        }

        setIsDelete(false)
        setProduct({})
    }

    React.useEffect(() => {
        handleproductList();
        handleCategory()
    }, []);

    return (
        <div className='main'>

            <div>
                <Navbar />
            </div>

            <div className='Admin_menu'>

                <Header show={1} sendNavbarToParent={navbarRender} />

                <h3 style={{ width: "100%", textAlign: "center", color: "rgb(5, 19, 120)", margin: 1 }}>Products</h3>
                <div className='addBlock1' onClick={() => { setIsAddVisible(true) }}>
                    <i class="fa fa-plus-square" data-tooltip-id="my-tooltip1" data-tooltip-content="Click To Add Product" ></i>
                </div>
                {productList == undefined ? <></> :
                    <div className='device_table'>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ borderRadius: "10px 0 0 10px" }}>S.No</th>
                                    <th>Products</th>
                                    <th>Product Category</th>
                                    <th style={{ borderRadius: " 0 10px 10px 0", textAlign: 'center' }} >Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {productList.map((item, index) => (
                                    <tr className="device_tr" key={index}>
                                        <td style={{ borderRadius: "10px 0 0 10px" }}>{index + 1}</td>
                                        <td >{item.part}</td>
                                        <td >{item.product_type}</td>
                                        <td className='action' style={{ borderRadius: " 0 10px 10px 0", textAlign: 'center' }}>
                                            <i className="fa-solid fa-pen" onClick={() => { editproduct(item) }}
                                                data-tooltip-id="my-tooltip1" data-tooltip-content="Click To Edit Product"></i>
                                            <i className="fa-solid fa-trash-can" onClick={() => { setProduct(item); setIsDelete(true) }}
                                                data-tooltip-id="my-tooltip1" data-tooltip-content="Click To Delete Product"></i>
                                        </td>
                                        <Tooltip id="my-tooltip1" />
                                    </tr>
                                ))}
                            </tbody>
                        </table>


                    </div>
                }

            </div>

            <Modal isOpen={isAddVisible}>

                <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <h2 style={{ margin: "0", padding: "0", fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif" }}>
                        {Object.keys(product).length === 0 ? "Add Product" : "Edit Product"}
                    </h2>
                    <i className="fa fa-close" onClick={() => { setIsAddVisible(false); setProduct(""); setSelectedCategoryOption({}) }}></i>
                </div>
                <div>
                    <div>
                        <label>Enter Product Name</label>
                        <input className='inputField'
                            type="text"
                            name="product"
                            value={product.part || ""}
                            onChange={(e) => handleChange("part", e.target.value)}
                        />
                    </div>
                    <div>
                        <label>Select Product Category</label>
                        <Select
                            options={categoryList}
                            value={selectedCategoryOption}
                            onChange={setSelectedCategoryOption}
                            placeholder="Select an option"
                            isSearchable
                        />
                    </div>

                    {
                        selectedCategoryOption != undefined && selectedCategoryOption.label == 'Other' ?
                            <div>
                                <label>Enter Other Category</label>
                                <input
                                    className="inputField"
                                    type="text"
                                    name="otherCategory"
                                    value={otherCategory || ""}
                                    onChange={(e) => setOtherCategory(e.target.value)}
                                />
                            </div> : <></>
                    }

                    <div>
                        <label>Enter Multiplier</label>
                        <input className='inputField'
                            type="text"
                            name="miltiplier"
                            value={product.miltiplier || ""}
                            onChange={(e) => handleChange("miltiplier", e.target.value)}
                        />
                    </div>

                    <div>
                        <label>Select Operand</label>
                        <Select
                            options={operandOptions}
                            value={selectedOperand == null ? product.operand : selectedOperand}
                            onChange={setSelectedOperand}
                            placeholder="Select an option"
                        />
                    </div>


                    <button onClick={submitProduct} style={{
                        backgroundColor: "#252B42 ", height: "30px", borderRadius: "10px", textDecoration: "none",
                        border: "0", marginTop: "30px", color: "white", fontSize: "15px", fontWeight: "500"
                    }}>Submit</button>
                </div>
            </Modal>

            <Modal isOpen={isDelete}>
                <h2 style={{ margin: "0", padding: "0", fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif" }}>
                    Are yoy sure you Delete {product.part} ?
                </h2>
                <div style={{ display: "inline-flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                    <h4 onClick={() => { setIsDelete(false); setProduct({}) }}>Close</h4>
                    <h4 onClick={deleteProduct}>Done</h4>
                </div>

            </Modal>
        </div >
    )
}

export default AddProduct
